import { FC } from "react";

export const Spinner: FC = () => (
    <div className="h-6 w-6 animate-spin rounded-full border-y-2 border-l-2 border-white border-y-gray-400 border-l-gray-400" data-testid="loading" />
);

export const FullPageSpinner: FC = () => {
  return (
        <div className="h-screen w-full flex items-center justify-center">
          <Spinner />
        </div>
    );
};